export enum PermitSource {
  Customer = 'Customer',
  SimpliSafe = 'SimpliSafe',
  MonitoringServiceProvider = 'MonitoringServiceProvider'
}
